import { useState, useEffect } from 'react';
import { useImpersonation } from '@center-technologies/shared-api-clients';
import { useApiClientsOrNull } from '../context/ApiClientsContext';
import { getUserCenters, UserCenter } from '../api/marketplaceApi';

export interface UseUserCentersResult {
  centers: UserCenter[];
  loading: boolean;
  error: string | null;
}

export function useUserCenters(): UseUserCentersResult {
  const apiClients = useApiClientsOrNull();
  const { impersonationDetails } = useImpersonation();
  const organizationId = impersonationDetails?.organizationId;

  const [centers, setCenters] = useState<UserCenter[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!apiClients || !organizationId) {
      return;
    }

    let cancelled = false;

    const fetchCenters = async () => {
      setLoading(true);
      setError(null);

      try {
        const response = await getUserCenters(apiClients.schemaClient);

        if (!cancelled) {
          setCenters(response.centers);
        }
      } catch (err) {
        if (!cancelled) {
          const message = err instanceof Error ? err.message : 'Failed to load centers';
          setError(message);
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };

    fetchCenters();

    return () => {
      cancelled = true;
    };
  }, [apiClients, organizationId]);

  return { centers, loading, error };
}
